import { render, staticRenderFns } from "./BottomFooter.vue?vue&type=template&id=2ac0a77a&scoped=true"
import script from "./BottomFooter.vue?vue&type=script&lang=js"
export * from "./BottomFooter.vue?vue&type=script&lang=js"
import style0 from "./BottomFooter.vue?vue&type=style&index=0&id=2ac0a77a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac0a77a",
  null
  
)

export default component.exports